import { ApolloError, useQuery } from '@apollo/client'
import { SelfReflectionQuestions } from '../../../graphql/self-reflection/SelfReflectionQueries'
import { SelfreflectionQuestionsQuery, SelfreflectionQuestionsQueryVariables } from '../../../types'

export default (
  employeeId: number,
  meetingId: number,
): {
  data: SelfreflectionQuestionsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<SelfreflectionQuestionsQuery, SelfreflectionQuestionsQueryVariables>(SelfReflectionQuestions, {
    variables: {
      employeeId: employeeId,
      meetingId: meetingId,
    },
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
